<div class="ctn-tags">
  <div class="swipe" *ngIf="tags">
    <button
      [ngClass]="isMobile && !activeAllTags ? 'tag-mobile' : ''"
      mb-button
      mb-button-small
      (click)="applyAllTags()"
      variant="{{ activeAllTags ? 'principal' : 'outline' }}"
      color="secondary"
    >
      <span i18n="@@tags_todas_las_fotos"
        >todas las fotos<span class="quantity">({{ allItems.length }})</span></span
      >
    </button>
    <button
      [ngClass]="isMobile && !tag.active ? 'tag-mobile' : ''"
      mb-button
      mb-button-small
      *ngFor="let tag of tags; let i = index"
      (click)="applyFilter(i, tag.name)"
      variant="{{ tag.active ? 'principal' : 'outline' }}"
      color="secondary"
    >
      <span
        >{{ tag.name }}<span class="quantity">({{ tag.total }})</span></span
      >
    </button>
  </div>
</div>
